import { writable }         from 'svelte/store';

export const currentStore = writable(void 0)